module.exports = __webpack_public_path__ + "img/floodfighting-20160720-04-1024x768.f2ad5440.jpg";